import { reducerCreator } from '@adrias-online/steiner';

import helper from 'helpers/steinerHelper';
import { actionTypes } from '../actions/hotel';

export const DEFAULT_STATE = helper.createDefaultState({
    list: {
        filters: {
            categoria: null,
            comune: null,
            posizione: null,
            produttore: null,
            customer_category: null,
        },
    },
});

const handlers = helper.createHandlers(actionTypes, {
    items: 'data.values',
    total: 'data.meta.pagination.total',
    idKey: 'idHotel',
});

export default reducerCreator.createReducer(handlers, DEFAULT_STATE);

export const selectors = reducerCreator.createSelectors('hotel');
